var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"61ad1d29022230c38a020249f1b3459820fef796"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["replai-platform-frontend@replai"]={id:"61ad1d29022230c38a020249f1b3459820fef796"};
      